<template>
  <div>
    <el-tabs v-model="chooseTab" type="card">
      <el-tab-pane
          v-for="(item, index) in orderTabs"
          :key="item.name"
          :label="item.label"
          :name="item.name"
        >
          <!-- 訂單詳情 -->
          <div v-if="item.name == 'info'">
            <div class="card box-shadow-sm">
              <div class="payment mb-3 table-responsive">
                <table class="table table-borderless">
                  <thead>
                    <tr class="order_table_tr" style="background: var(--primary_color)">
                      <td class="order_table_td">
                        <div class="order_table_info_div">
                          <div class="order_table_info_div_1 py-2">
                            <span class="d-block spandHeadO">{{ t("orders.id") }}: </span>
                          </div>
                          <div class="order_table_info_div_2">
                            <div><span class="spanTr"> {{ order.id }} </span></div>
                            <div v-if="order.additional_data.ocerp_order_ids">
                              <span v-for="ocerp_order_id in order.additional_data.ocerp_order_ids" class="badge badge-info"> OCERP訂單: {{ ocerp_order_id }} </span>
                            </div>
                          </div>
                        </div>
                      </td>
                      <td class="order_table_td">
                        <div class="order_table_info_div">
                          <div class="order_table_info_div_1 py-2">
                            <span class="d-block spandHeadO">{{ t("orders.createAt") }}: </span>
                          </div>
                          <div class="order_table_info_div_2">
                            <span class="spanTr"> {{ dateFormat(order.created_at, "YYYY/MM/DD hh:mm A") }} </span>
                          </div>
                        </div>
                      </td>
                      <td class="order_table_td">
                        <div class="order_table_info_div">
                          <div class="order_table_info_div_1 py-2">
                            <span class="d-block spandHeadO">{{ t("orders.paymentMethod") }}: </span>
                          </div>
                          <div class="order_table_info_div_2">
                            <span class="spanTr"> {{ printPaymentName(order.payment_type) }}
                              <span v-if="order.paid_last_at">({{ dateFormat(order.paid_last_at, "YYYY/MM/DD hh:mm A") }})</span>
                            </span>
                          </div>
                        </div>
                      </td>
                      <td class="order_table_td">
                        <div class="order_table_info_div">
                          <div class="order_table_info_div_1 py-2">
                            <span class="d-block spandHeadO">{{ t("orders.shippingMethod") }}: </span>
                          </div>
                          <div class="order_table_info_div_2">
                            <div v-for="logistic in order.logistics">
                              <span class="spanTr"> {{ printLogisticInfo(logistic) }} </span>
                            </div>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </thead>
                </table>

                <table v-for="group in groupedItems" :key="group.event_key" class="table table-borderless">
                  <thead v-if="group.event_name">
                    <tr>
                      <th colspan="3" class="text-center bg-secondary text-dark">
                        {{ group.event_name }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in group.items" :key="item.id">
                      <td class="col-2 for-tab-img">
                        <img
                          class="d-block"
                          :src="item.img_url || '/static/assets/front-end/img/image-place-holder.png'"
                          :alt="`${item.prod_name}-${item.prod_assort_name}`"
                          width="60"
                        />
                      </td>
                      <td class="col-10 for-glaxy-name" style="vertical-align:middle;">
                        <span v-if="item.ptype == 'SGIFT'" class="badge badge-info mr-2">
                          {{ $t("carts.gift") }}
                        </span>
                        <span v-else-if="item.ptype == 'SADDT'" class="badge badge-info mr-2">
                          {{ $t("carts.addOn") }}
                        </span>
                        <a :href="`/products/${item.store_product_id}`" target="_blank">
                          {{ item.prod_name }}
                        </a>
                        <br/><span>{{ checkValidCurrencyStr(item.unit_price, order.currency) }} - {{ item.prod_assort_name }}</span>
                        <!--<br/><span v-for="status_label in item.status_labels" class="badge badge-info mr-2">{{ status_label }}</span>-->
                      </td>
                      <td width="100%">
                        <div class="text-right whitespace-nowrap">
                          <span class="font-weight-bold amount">
                            {{ checkValidCurrencyStr(item.price, order.currency) }}
                          </span>

                          <br /><span>{{ t("orders.qty") }}: {{ n(item.quantity) }}</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                  <tfoot v-if="!!group.assort_discount || !!group.prom_discount">
                    <tr>
                      <td colspan="3">
                        <div class="d-flex flex-row justify-content-end">
                          <h5>
                            <span v-if="group.assort_discount" class="badge badge-warning mr-2">
                              {{ t("orders.assortDiscount") }}:
                              {{ checkValidCurrencyStr(group.assort_discount, order.currency) }}
                            </span>
                            <span v-if="group.prom_discount" class="badge badge-primary">
                              {{ t("orders.promDiscount") }}:
                              {{ checkValidCurrencyStr(group.prom_discount, order.currency) }}
                            </span>
                          </h5>
                        </div>
                      </td>
                    </tr>
                  </tfoot>
                </table>

              </div>
            </div>

            <!-- Calculation -->
            <div class="row d-flex justify-content-end">
              <div class="col-md-8 col-lg-5">
                <table class="table table-borderless">
                  <tbody class="totals">
                    <tr v-if="order.items_total">
                      <td>
                        <div class="text-left">
                          <span class="product-qty ">{{ t("orders.subtotal") }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="text-right">
                          <span>{{ checkValidCurrencyStr(order.items_total, order.currency) }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="order.fees_insurance">
                      <td>
                        <div class="text-left">
                          <span class="product-qty ">{{ t("orders.insuranceFees") }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="text-right">
                          <span>{{ checkValidCurrencyStr(order.fees_insurance, order.currency) }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="order.fees_delivery">
                      <td>
                        <div class="text-left">
                          <span class="product-qty ">{{ t("orders.deliveryFees") }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="text-right">
                          <span>{{ checkValidCurrencyStr(order.fees_delivery, order.currency) }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="order.fees_payment">
                      <td>
                        <div class="text-left">
                          <span class="product-qty ">{{ t("orders.paymentFees") }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="text-right">
                          <span>{{ checkValidCurrencyStr(order.fees_payment, order.currency) }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="order.fees_other">
                      <td>
                        <div class="text-left">
                          <span class="product-qty ">{{ t("orders.otherFees") }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="text-right">
                          <span>{{ checkValidCurrencyStr(order.fees_other, order.currency)}}</span>
                        </div>
                      </td>
                    </tr>
                    <tr v-if="order.fees_discount">
                      <td>
                        <div class="text-left">
                          <span class="product-qty ">{{ t("orders.discount") }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="text-right">
                          <span>- {{ checkValidCurrencyStr(order.fees_discount, order.currency) }}</span>
                        </div>
                      </td>
                    </tr>
                    <tr class="border-top border-bottom">
                      <td>
                        <div class="text-left">
                          <span class="font-weight-bold">{{ t("orders.total") }}</span>
                        </div>
                      </td>
                      <td>
                        <div class="text-right">
                          <span class="font-weight-bold amount">
                            {{ checkValidCurrencyStr(order.total, order.currency) }}
                          </span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>

          <!-- 出貨單 -->
          <div v-else-if="item.name == 'delivery'">
            <el-empty v-if="order.deliveries.length == 0" description="尚無出貨單"></el-empty>
            <div v-else class="card box-shadow-sm" v-for="delivery in order.deliveries">
              <div class="payment mb-3 table-responsive">
                <table class="table table-borderless">
                  <thead>
                    <tr class="order_table_tr" style="background: var(--primary_color)">
                      <td class="order_table_td">
                        <div class="order_table_info_div">
                          <div class="order_table_info_div_1 py-2">
                            <span class="d-block spandHeadO">{{ t("orders.trackingNo") }}: </span>
                          </div>
                          <div class="order_table_info_div_2">
                            <span class="spanTr"> {{ delivery.tracking_no }} </span>
                          </div>
                        </div>
                      </td>
                      <td class="order_table_td">
                        <div class="order_table_info_div">
                          <div class="order_table_info_div_1 py-2">
                            <span class="d-block spandHeadO">{{ t("orders.shippingMethod") }}: </span>
                          </div>
                          <div class="order_table_info_div_2">
                            <span class="spanTr"> {{ printLogisticInfo(delivery) }} </span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </thead>
                </table>

                <table class="table table-borderless">
                  <thead>
                    <tr>
                      <th colspan="3" class="text-center bg-secondary text-dark">
                        {{ t("orders.shippingLogs") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr>
                      <td colspan="3">
                        <el-timeline :reverse="false">
                          <el-timeline-item
                            v-for="(log, index) in delivery.logs"
                            :key="index"
                            :timestamp="dateFormat(log.created_at, 'YYYY/MM/DD hh:mm A')">
                            {{log.msg}}
                          </el-timeline-item>
                        </el-timeline>
                    </td>
                    </tr>
                  </tbody>
                </table>

                <table class="table table-borderless">
                  <thead>
                    <tr>
                      <th colspan="3" class="text-center bg-secondary text-dark">
                        {{ t("orders.shippingDetails") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in delivery.items" :key="item.id">
                      <td class="col-2 for-tab-img">
                        <img
                          class="d-block"
                          :src="item.img_url || '/static/assets/front-end/img/image-place-holder.png'"
                          :alt="`${item.prod_name}-${item.prod_assort_name}`"
                          width="60"
                        />
                      </td>
                      <td class="col-10 for-glaxy-name" style="vertical-align:middle;">
                        {{ item.prod_name }}
                        <br/><span>{{ item.prod_assort_name }}</span>
                      </td>
                      <td width="100%">
                        <div class="text-right whitespace-nowrap">
                          <span>{{ t("orders.qty") }}: {{ n(item.quantity) }}</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>

          <!-- 退款單 -->
          <div v-else-if="item.name == 'refund'">
            <el-empty v-if="order.refunds.length == 0" description="尚無退款單"></el-empty>
            <div v-else class="card box-shadow-sm">
              <div class="payment mb-3 table-responsive">
                <table class="table table-borderless">
                  <thead>
                    <tr class="order_table_tr" style="background: var(--primary_color)">
                      <td class="order_table_td">
                        <div class="order_table_info_div">
                          <div class="order_table_info_div_1 py-2">
                            <span class="d-block spandHeadO">{{ t("orders.refundMethod") }}: </span>
                          </div>
                          <div class="order_table_info_div_2">
                            <span class="spanTr"> {{ printPaymentName(order.payment_type) }} </span>
                          </div>
                        </div>
                      </td>
                      <td v-if="order.payment_type == 'VATM'" class="order_table_td">
                        <div class="order_table_info_div">
                          <div class="order_table_info_div_1 py-2">
                            <span class="d-block spandHeadO">{{ t("orders.refundAccount") }}: </span>
                          </div>
                          <div class="order_table_info_div_2">
                            <span v-if="order.refund_data" class="spanTr"> {{ printRefundInfo(order.refund_data) }} </span>
                            <span v-else class="spanTr">尚未設定退款帳戶</span>
                          </div>
                        </div>
                      </td>
                    </tr>
                  </thead>
                </table>

                <table class="table table-borderless">
                  <thead>
                    <tr>
                      <th colspan="3" class="text-center bg-secondary text-dark">
                        {{ t("orders.refundDetails") }}
                      </th>
                    </tr>
                  </thead>
                  <tbody>
                    <tr v-for="item in order.refunds" :key="item.id">
                      <td class="col-2 for-tab-img">
                        <img
                          class="d-block"
                          :src="item.img_url || '/static/assets/front-end/img/image-place-holder.png'"
                          :alt="`${item.prod_name}-${item.prod_assort_name}`"
                          width="60"
                        />
                      </td>
                      <td class="col-10 for-glaxy-name" style="vertical-align:middle;">
                        <!-- 訂單整張取消 -->
                        <template v-if="item.type == 1">
                          整單退款
                        </template>
                        <!-- 單筆item退款 -->
                        <template v-else>
                          {{ item.prod_name }}
                          <br/><span>{{ item.prod_assort_name }}</span>
                        </template>
                        <br/>
                        <span v-if="item.status == '0100'" class="badge badge-info mr-2">{{ t("orders.refundStatus.pending") }}</span>
                        <span v-else-if="item.status == '0200'" class="badge badge-info mr-2">{{ t("orders.refundStatus.processing") }}</span>
                        <span v-else-if="item.status == '9800'" class="badge badge-info mr-2">{{ t("orders.refundStatus.canceled") }}</span>
                        <span v-else-if="item.status == '9900'" class="badge badge-info mr-2">{{ t("orders.refundStatus.done") }} ({{ dateFormat(item.done_at, 'YYYY/MM/DD hh:mm A') }})</span>
                        <span v-else class="badge badge-info mr-2">{{ item.status }}</span>
                      </td>
                      <td width="100%">
                        <div class="text-right whitespace-nowrap">
                          <span class="font-weight-bold amount">
                            {{ t("orders.refundAmount") }}: {{ checkValidCurrencyStr(item.amount, item.currency) }}
                          </span>
                          <br/><span v-if="item.type != 1">{{ t("orders.refundQty") }}: {{ n(item.quantity) }}</span>
                        </div>
                      </td>
                    </tr>
                  </tbody>
                </table>

              </div>
            </div>
          </div>
      </el-tab-pane>
    </el-tabs>
  </div>
</template>

<script setup>
import { computed, ref } from 'vue'
import { useI18n } from "vue-i18n"
import { checkValidCurrencyStr, dateFormat, dataTranslations as dt } from "../../utils"

const props = defineProps({
  order: Object,
  payments: Array,
  logistics: Array,
})

const { t, n, locale } = useI18n()

const orderTabs = [
  {"label": "訂單詳情", "name": "info"},
  {"label": "出貨單", "name": "delivery"}
]

const chooseTab = ref('info')

const paymentMap = computed(() => _.keyBy(props.payments, "type"));
const logisticMap = computed(() => _.keyBy(props.logistics, "delivery_type"));
const promotionMap = computed(() => props.order.additional_data.event_map || {})
const items = computed(() => {
  // 過濾商品類型
  const ptypes = ["SPROD", "SGIFT", "SADDT", "PLAN"]
  return props.order.items.filter((item) => ptypes.includes(item.ptype))
})
const groupedItems = computed(() => {
  // 依活動分割商品
  const grouped = _.groupBy(items.value, (item) => {
    return item.event_group_uuid ? item.event_group_uuid : null;
  })
  // console.log("grouped:", grouped)

  const formatted = _.reduce(grouped, (rst, val, key) => {
    let event = val[0]
    let event_name = t("orders.productDetails")
    let promotion = null
    // console.log("key:", key)
    // console.log("rst:", rst)
    // console.log("val:", val)

    if (key && event.event_id) {
      promotion = promotionMap.value[event.event_id]
      event_name = promotion.title
    }
    let count = 0
    let assort_org_total = 0
    let assort_total = 0
    let prom_discount = 0
    let discount_price = 0
    let assort_discount = 0

    val.forEach(item => {
      count += item.quantity
      assort_org_total += item.price
      // 網紅價
      if (item?.discounted_price) {
        assort_total += item.discounted_price
      }
      if (item?.discount_price) {
        discount_price += item.discount_price
      }
    })
    if (!assort_total) {
      assort_total = assort_org_total
    }
    assort_discount = assort_org_total - assort_total

    // 活動折扣
    if (promotion) {
      let prom_discount_info = getPromotionDiscount(promotion, assort_total, count)
      prom_discount = prom_discount_info.prom_discount
      console.log("getPromotionDiscount: ", prom_discount_info)
    }

    rst[key] = {
      event_key: key,
      event_name,
      items: val,
      count,
      assort_org_total,
      assort_total,
      assort_discount,
      discount_price,
      prom_discount,
      prom_id: promotion ? promotion.id : null,
    }

    return rst
  }, {})
  // console.log("formatted:", formatted)

  return formatted
})

const getPromotionDiscount = (promotion, assort_total, assort_count) => {
  let prom_discount = 0 // 活動折扣
  if (!promotion) return prom_discount

  let discount_type = promotion.discount_type
  let discount_value = null
  let choose_gift_store_product_ids = []
  let choose_gift_qty = 0

  // 滿額
  if (promotion.condition_min_type == 'amount') {
    promotion.conditions.forEach((condition) => {
      if (assort_total >= condition.min_amount) {
        if (discount_type == 'amount') {
          discount_value = condition.discount_amount
        } else if (discount_type == 'percentage') {
          discount_value = condition.discount_percentage
        } else if (discount_type == 'gift') {
          choose_gift_store_product_ids = condition.discountable_store_product_ids
          choose_gift_qty = condition.discountable_quantity
        }
      }
    })
  }
  // 滿件
  else if (promotion.condition_min_type == 'qty') {
    promotion.conditions.forEach((condition) => {
      if (assort_count >= condition.min_qty) {
        if (discount_type == 'amount') {
          discount_value = condition.discount_amount
        } else if (discount_type == 'percentage') {
          discount_value = condition.discount_percentage
        } else if (discount_type == 'gift') {
          choose_gift_store_product_ids = condition.discountable_store_product_ids
          choose_gift_qty = condition.discountable_quantity
        }
      }
    })
  }

  if (discount_type && discount_value) {
    if (discount_type == 'amount') {
      prom_discount = discount_value
    } else if (discount_type == 'percentage') {
      prom_discount = assort_total * (discount_value/100)
    }
  }

  const promDiscountableStoreProductMap = _.keyBy(promotion.discountable_store_products, "id")
  let choose_gifts = []
  choose_gift_store_product_ids.forEach((store_product_id) => {
      const gift = promDiscountableStoreProductMap[store_product_id.toString()]
      if (gift) {
        choose_gifts.push(gift)
      }
  })

  return {
    "prom_discount": prom_discount,
    "choose_gifts": choose_gifts,
    "choose_gift_qty": choose_gift_qty,
  }
}

const printPaymentName = (payment_type) => {
  if (!paymentMap.value[payment_type]) {
    return payment_type
  }
  return dt(paymentMap.value[payment_type].name_translations)
}

const printDeliveryName = (delivery_type) => {
  if (!logisticMap.value[delivery_type]) {
    return delivery_type
  }
  return dt(logisticMap.value[delivery_type].name_translations)
}

const printLogisticInfo = (logistic) => {
  const delivery_type = logistic.delivery_type
  let receiver = ""
  let address = ""
  if (logistic.cust_data) {
    receiver = logistic.cust_data.to_name + " (" + logistic.cust_data.to_mobile + ")"
    if (delivery_type == "HOME") {
      address = logistic.cust_data.province + logistic.cust_data.city + logistic.cust_data.address
    }
    else if (delivery_type == "CVS_UNIMART" || delivery_type == "CVS_FAMI" || delivery_type == "CVS_HILIFE" || delivery_type == "CVS_OKMART") {
      address = logistic.logistic_data.shop_name
    }
  }
  return "【" + printDeliveryName(delivery_type) + "】" + address + " - " + receiver
}

const printRefundInfo = (refund_data) => {
  if (refund_data.channel == 'bank') {
    const bank_info = refund_data.bank_info
    const account_no = "********" + bank_info.account_no.substr(-4)
    return "【" + bank_info.bank_branch_name + "】" + bank_info.bank_name + " - " + account_no + " (" + bank_info.account_name + "）"
  }
}
</script>
